import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-4 p-6 rounded-xl border border-gray-lp-1300" }
const _hoisted_2 = { class: "flex flex-row gap-x-4" }
const _hoisted_3 = { class: "font-semibold text-black-lp-300 flex flex-row" }
const _hoisted_4 = { class: "text-gray-lp-500 font-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, { class: "w-full mr-4" }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t("bookingShipment.column.manualSttNumber")) + " ", 1),
            _createVNode("p", null, [
              _createVNode("span", _hoisted_4, "(" + _toDisplayString(_ctx.$t("optional")) + ")", 1)
            ])
          ]),
          _createVNode(_component_lp_input, {
            class: "my-2",
            isFirstInput: _ctx.isFirstInput,
            error: _ctx.error.sttManual,
            errorCaption: _ctx.errorCaptionSttManual,
            disabled: _ctx.isDisabledSttManual,
            errorIcon: false,
            onChange: _cache[1] || (_cache[1] = 
            (value) => {
              _ctx.validateSttManual(value, _ctx.modelValue);
            }),
            modelValue: _ctx.modelValue.sttManual,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue.sttManual = $event))
          }, null, 8, ["isFirstInput", "error", "errorCaption", "disabled", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        id: "repair-external-number",
        label: _ctx.$t('bookingShipment.column.externalRefNumber'),
        optional: _ctx.refNumberOpsionalOrAsterik,
        class: "w-full"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_lp_input, {
            modelValue: _ctx.modelValue.referenceExternal,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.referenceExternal = $event)),
            placeholder: _ctx.$t('bulkBooking.form.externalReferenceExample'),
            errorIcon: false,
            errorCaption: _ctx.errorReferenceNumber,
            showMaxLength: true,
            maxLength: 100,
            onChange: _ctx.validateRefNumber,
            error: this.getErrorMandatory,
            onFocus: _ctx.setErroMandatory
          }, null, 8, ["modelValue", "placeholder", "errorCaption", "onChange", "error", "onFocus"])
        ]),
        _: 1
      }, 8, ["label", "optional"])
    ]),
    (_ctx.isClientAccount || _ctx.isClientBooking)
      ? (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 0,
          id: "repair-shipment-id",
          label: _ctx.$t('bookingShipment.column.shipmentId'),
          optional: true,
          class: "w-1/2 pr-4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.modelValue.sttShipmentId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelValue.sttShipmentId = $event)),
              placeholder: "",
              errorIcon: false,
              errorCaption: _ctx.errorShipmentId,
              error: _ctx.error.sttShipmentId,
              onChange: _ctx.validateShipmentId
            }, null, 8, ["modelValue", "errorCaption", "error", "onChange"])
          ]),
          _: 1
        }, 8, ["label"]))
      : _createCommentVNode("", true)
  ]))
}